/** Billing-identity services (T034). Typed callable wrappers for validation + upsert. */
import { callable } from './firebase';
import type { BillingIdentity, BillingSystem, CallableResult, IdBasis } from '../types/entities';

export interface ValidationResult {
  resolves: boolean;
  expected_id_basis?: IdBasis;
  warnings: string[];
}

export interface ValidateInput {
  system: BillingSystem;
  external_id: string;
  id_basis?: IdBasis;
  alegra_id?: string | null;
}

export const validateBillingIdentity = callable<ValidateInput, ValidationResult>(
  'validateBillingIdentity',
);

export type UpsertBillingIdentityInput = Partial<BillingIdentity> & {
  client_id: string;
  system: BillingSystem;
  external_id: string;
  billing_country: string;
};

export const upsertBillingIdentity = callable<
  UpsertBillingIdentityInput,
  CallableResult<BillingIdentity>
>('upsertBillingIdentity');
